<script>
    import Button from './components/Button.svelte';

    import Msg from './components/Msg.svelte';

    import {activeStepStore, progressBarDownloadUrl} from './stores';

    export let form;

    function validateButtonPress(){
        if(!form.checkValidity()){
            form.reportValidity();
            return false;
        }else return true;
    }

    function prevPage(){
        if(!validateButtonPress())
            return;
        $activeStepStore -= 1;
    }

    function nextPage(){
        if(!validateButtonPress())
            return;
        $activeStepStore += 1;
    }

    function previewDownload(){
        if(!validateButtonPress())
            return;

        if($activeStepStore !== 4){
            onPreview();
        }else{
            onDownload();
        }
    }

    function onPreview(){
        window.dispatchEvent(new CustomEvent("progressBarDownloadEvent"));
    }

    function onDownload(){
        let a = document.createElement("a");
        a.download = "ProgressBar" + $progressBarDownloadUrl.ext;
        a.href = $progressBarDownloadUrl.url;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
    }
</script>

<div class="py-1 flex flex-col sm:flex-row justify-evenly">
    {#if $activeStepStore !== 1}
    <Button on:click={prevPage}><Msg id="app.buttons.back" defaultMessage="Back" /></Button>
    {/if}
    <Button on:click={previewDownload} success={$activeStepStore === 4}>
        {#if $activeStepStore === 4}
        <Msg id="app.buttons.download" defaultMessage="Download" />
        {:else}
        <Msg id="app.buttons.preview" defaultMessage="Preview" />
        {/if}
    </Button>
    {#if $activeStepStore !== 4}
    <Button on:click={nextPage}><Msg id="app.buttons.next" defaultMessage="Next" /></Button>
    {/if}
</div>